import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { ENABLE_OPT_IN_NUDGE } from "@faire/web-api--source/indigofair/settings/ENABLE_OPT_IN_NUDGE";

export const getSettingEnableOptInNudge = (): boolean =>
  getSettingValueWithoutAssignment(ENABLE_OPT_IN_NUDGE, false);
